import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '@material-ui/core';
import { useStyles } from './style';

const InputMaskCustom = ({ 
  mask, 
  value, 
  onChange, 
  onBlur, 
  label, 
  name, 
  error, 
  helperText, 
  placeholder,
  disabled,
  ...rest 
}) => {
    const classes = useStyles()

    const [isFocused] = useState(false)
  return (
    <div className={classes.root}>
      {label && (
        <label
          htmlFor={name}
          className={`${classes.inputLabel} ${
            isFocused ? classes.inputLabelFocused : ''
          }`}
        >
          {label}
        </label>
      )}
    <InputMask
      mask={mask}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      maskChar={null} // Mantém o input limpo sem underscores (_)
    >
      {(inputProps) => (
        <TextField
          {...inputProps}
          {...rest}
          variant="outlined"
          fullWidth
          name={name}
        //   label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          className={classes.inputField}
        />
      )}
    </InputMask>
    </div>
  );
};

export default InputMaskCustom;